module.exports = __webpack_public_path__ + "img/img1.10795726.png";